import ModulesHelper from '@core/services/modules.helper';
import AuthorizationHelper from '@auth/services/authorization.helper';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class LeagueSidebarEntriesMixin extends Vue {
  declare hideMenuItem: boolean;

  get leagueMenuEntriesTabs() {
    return ['main'];
  }

  get leagueMainMenuEntries() {
    return [
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.dashboard'),
        hidden: this.hideMenuItem,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        icon: 'pe-7s-home',
        title: this.$t('global.sidebar_menu.main_menu.dashboard'),
        hidden: this.hideMenuItem,
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.league.admin_management'),
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/contacts`),
        title: this.$t('global.sidebar_menu.main_menu.league.contacts'),
        icon: 'pe-7s-user',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/subscriptions`),
        title: this.$t('global.sidebar_menu.main_menu.league.memberships'),
        icon: 'pe-7s-id',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/entries`),
        title: this.$t('global.sidebar_menu.main_menu.league.entries'),
        icon: 'pe-7s-way',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.entries],
        module: ModulesHelper.ENTRIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/certificates`),
        title: this.$t('global.sidebar_menu.main_menu.league.certificates'),
        icon: 'pe-7s-paperclip',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.certificates],
        module: ModulesHelper.CERTIFICATES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/documents`),
        title: this.$t('global.sidebar_menu.main_menu.league.documents'),
        icon: 'pe-7s-albums',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.documents],
        module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/orders`),
        title: this.$t('global.sidebar_menu.main_menu.orders'),
        icon: 'pe-7s-cart',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.orders],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/invoices/orders/waiting`),
        title: this.$t('global.sidebar_menu.main_menu.invoices'),
        icon: 'pe-7s-next-2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/credit-notes/orders/waiting`),
        title: this.$t('global.sidebar_menu.main_menu.credit_notes'),
        icon: 'pe-7s-back-2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/tickets`),
        title: this.$t('global.sidebar_menu.main_menu.tickets'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.tickets],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/payments`),
        title: this.$t('global.sidebar_menu.main_menu.payments'),
        icon: 'pe-7s-credit',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.payments],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/coupons`),
        title: this.$t('global.sidebar_menu.main_menu.coupons'),
        icon: 'pe-7s-gift',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.coupons],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.league.clubs_management'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/contacts/clubs`),
        title: this.$t('global.sidebar_menu.main_menu.league.clubs'),
        icon: 'pe-7s-shield',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/contacts/teams`),
        title: this.$t('global.sidebar_menu.main_menu.league.teams'),
        icon: 'pe-7s-users',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.licences'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-id',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.league.sport_management'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/enrollments`),
        title: this.$t('global.sidebar_menu.main_menu.league.enrollments'),
        icon: 'pe-7s-ticket',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.enrollments],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activities`),
        title: this.$t('global.sidebar_menu.main_menu.league.activities'),
        icon: 'pe-7s-cup',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activity-groups`),
        title: this.$t('global.sidebar_menu.main_menu.league.groups'),
        icon: 'pe-7s-albums',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_groups],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activity-sessions`),
        title: this.$t('global.sidebar_menu.main_menu.activity_sessions'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-gym',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_sessions],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.series'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-photo-gallery',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.games'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-date',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.rankings'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-network',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.league.judicial_management'),
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.suspensions'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-close-circle',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.fines'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-cash',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.league.referees_management'),
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.referees'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-users',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.availabilities'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-date',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.league.nominations'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-shuffle',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.monitoring'),
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.statistics'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-graph2',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.reporting'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-note2',
        exactPath: true,
      },
    ];
  }
}
